import { List, Record } from 'immutable'
import { ITenantRent, TenantRent } from './TenantRent'

export interface IPropertyFinancialDetails {
  readonly insuranceExpenses: number
  readonly otherExpenses: number
  readonly realEstateTaxes: number
  readonly rentDetails: List<ITenantRent>
}

const PropertyFinancialDetailsRecord = Record({
  insuranceExpenses: 0,
  otherExpenses: 0,
  realEstateTaxes: 0,
  rentDetails: List<TenantRent>(),
})

export class PropertyFinancialDetails extends PropertyFinancialDetailsRecord
  implements IPropertyFinancialDetails {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new PropertyFinancialDetails()
    }

    const { rentDetails, ...rest } = initialState

    return new PropertyFinancialDetails({
      rentDetails: Array.isArray(rentDetails)
        ? rentDetails.map((r) => TenantRent.fromJS(r))
        : List<TenantRent>(),
      ...rest,
    })
  }

  public readonly insuranceExpenses: number
  public readonly otherExpenses: number
  public readonly realEstateTaxes: number
  public readonly rentDetails: List<ITenantRent>

  constructor(props?: Partial<PropertyFinancialDetails>) {
    props ? super(props) : super()
  }
}
